module.exports = __webpack_public_path__ + "img/adam.2ec99e55.jpeg";